import React from 'react';
const WeddingParty = () => {
  const weddingParty = [{
    name: 'Faith',
    role: 'Maid of Honor',
    relation: 'Sister of the Bride',
    image: 'https://cdn.magicpatterns.com/uploads/9kCcL9QgnGWkGdL3vji4ys/Faith.jpg'
  }, {
    name: 'Kayikunmi',
    role: 'Best Man',
    relation: 'Friend of the Groom',
    image: 'https://cdn.magicpatterns.com/uploads/aTqB3A8ua7DEUQqMCvmKvU/IMG_5323.jpg'
  }];
  return <section id="wedding-party" className="bg-champagne bg-opacity-20 py-20" data-id="element-144">
      <div className="section-container" data-id="element-145">
        <h2 className="section-heading" data-id="element-146">Our Wedding Party</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-147">
          {weddingParty.map((person, index) => <div key={index} className="bg-white rounded-md overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300" data-id="element-148">
              <div className="h-96 overflow-hidden" data-id="element-149">
                <img src={person.image} alt={person.name} className="w-full h-full object-cover object-top transition-transform duration-500 hover:scale-105" data-id="element-150" />
              </div>
              <div className="p-6 text-center" data-id="element-151">
                <h3 className="font-serif text-xl text-gray-800 mb-1" data-id="element-152">
                  {person.name}
                </h3>
                <p className="text-gold font-medium mb-2" data-id="element-153">{person.role}</p>
                <p className="text-gray-600 text-sm" data-id="element-154">{person.relation}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default WeddingParty;